import { iosDownloadUrl } from '@/constant';
import platform from '../platform';

// 针对 ios 报网址无效的场景，3s 后 自动跳转 appstore 下载app
export const iOSRedirect = (): void => {
  if (platform.isIOS) {
    const timer = setTimeout(() => {
      // 如果页面没隐藏 用户留在当前页面时长大于2s时，跳转 appstore
      if (!document.hidden) window.location.href = iosDownloadUrl;
    }, 3000);

    document.addEventListener('visibilitychange', () => {
      // 用户离开时，清除定时器
      clearTimeout(timer);
    });
  }
};
